import { render, staticRenderFns } from "./i4pro-table.vue?vue&type=template&id=aca8e412&scoped=true"
import script from "./i4pro-table.vue?vue&type=script&lang=js"
export * from "./i4pro-table.vue?vue&type=script&lang=js"
import style0 from "./i4pro-table.vue?vue&type=style&index=0&id=aca8e412&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca8e412",
  null
  
)

export default component.exports